import { render, staticRenderFns } from "./task_messaging_button.vue?vue&type=template&id=d3ffdcc0&scoped=true"
import script from "./task_messaging_button.vue?vue&type=script&lang=js"
export * from "./task_messaging_button.vue?vue&type=script&lang=js"
import style0 from "./task_messaging_button.vue?vue&type=style&index=0&id=d3ffdcc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ffdcc0",
  null
  
)

export default component.exports